module.exports = __webpack_public_path__ + "img/20161119_104809-1 (2).9f86ba62.jpg";